import { Map } from 'immutable'

/**
 * @param {ReduxState} state redux state
 * @returns {Map}
 */
export function selectOracle (state) {
  return state.oracle || Map()
}

/**
 * @param {ReduxState} state redux state
 * @returns {Map}
 */
export function selectOracleAccess (state) {
  return selectOracle(state).get('access', Map())
}

/**
 * @param {ReduxState} state redux state
 * @returns {Boolean}
 */
export function selectHasVoiceAccess (state) {
  const access = selectOracleAccess(state)
  return access.get('aiSpeech', false)
}

/**
 * @param {ReduxState} state redux state
 * @returns {Boolean}
 */
export function selectHasUnlimitedChat (state) {
  const access = selectOracleAccess(state)
  return access.get('aiTextUnlimited', false)
}

/**
 * @param {ReduxState} state redux state
 * @returns {Boolean}
 */
export function selectOracleAccessProcessing (state) {
  return selectOracle(state).get('accessProcessing', false)
}

/**
 * @param {ReduxState} state redux state
 * @returns {boolean} true if guide is closed, false if open
 */
export function selectOracleGuideOnSideClosed (state) {
  return selectOracle(state).get('guideOnSideClosed', false)
}

/**
 * @param {ReduxState} state redux state
 * @returns {boolean} true if user is eligible to see the guide (passes Gaia config + PostHog flags)
 */
export function selectOracleGuideEnabled (state) {
  return selectOracle(state).get('guideEnabled', false)
}

/**
 * @param {ReduxState} state redux state
 * @returns {string|null} contentId of the video for which the toast nudge was dismissed
 */
export function selectOracleToastDismissedContentId (state) {
  return selectOracle(state).get('toastNudgeDismissedContentId', null)
}

// TODO: Future - pin/unpin functionality (commented for v1)
// /**
//  * @param {ReduxState} state redux state
//  * @returns {string} One of: 'closed', 'unpinned', 'pinned'
//  */
// export function selectOracleGuideOnSideState (state) {
//   return selectOracle(state).get('guideOnSideState', 'unpinned')
// }
